import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DonateNowModule } from '../donate-now/donate-now.module';
import { DonorModule } from '../donor/donor.module';
import { FrCardModule } from '../fr-card/fr-card.module';
import { PlaceholderLoaderModule } from '../placeholder-loader/placeholder-loader.module';
import { ViewSupportersComponent } from './components/view-supporters/view-supporters.component';
import { ButtonModule } from '../button/button.module';
import { TickrModule } from '../tickr/tickr.module';
import { SharedModule } from '../../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { SigninSignupComponent } from 'src/app/core/signin-signup/signin-signup.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    FrCardModule,
    PlaceholderLoaderModule,
    DonateNowModule,
    SharedModule,
    DonorModule,
    ButtonModule,
    TickrModule,
    SigninSignupComponent
  ],
  declarations: [ViewSupportersComponent],
  exports: [ViewSupportersComponent],
})
export class ViewSupportersModule { }
